import React from "react";
import {
  Section, LinkedInGithub, EduRow, ExpBlock, Bullets, ProjectLink,
  SkillsTwoCol, Achievements,
} from "./shared";

const T = ({ children }) => <h2>{children}</h2>;

const Template5 = ({ data }) => (
  <div className="rt rt5">
    <div className="rt-header">
      <h1>{data.fullName}</h1>
      <p>{[data.email, data.phoneNo].filter(Boolean).join(" | ")}</p>
      {(data.linkedinId || data.githubId) && (
        <p><LinkedInGithub data={data} /></p>
      )}
      {data.location && <p>{data.location}</p>}
    </div>

    <Section
      title={<T>Professional Summary</T>}
      items={[data.summary && <p>{data.summary}</p>]}
    />
    <Section
      title={<T>Technical Skills</T>}
      items={[
        data.skills.length > 0 && (
          <SkillsTwoCol skills={data.skills} className="rt-grid" />
        ),
      ]}
    />
    <Section
      title={<T>Projects</T>}
      items={data.projects.map((p, i) => (
        <div key={i} className="rt-avoid rt-item">
          <h3>{p.projectName}</h3>
          <Bullets points={p.description} />
          <ProjectLink url={p.projectLink} />
        </div>
      ))}
    />
    <Section
      title={<T>Internship / Training</T>}
      items={
        data.experiences.length
          ? data.experiences.map((x, i) => <ExpBlock key={i} exp={x} />)
          : [<p>Fresher</p>]
      }
    />
    <Section
      title={<T>Education</T>}
      items={data.education.map((e, i) => <EduRow key={i} edu={e} />)}
    />
    <Section
      title={<T>Achievements / Certifications</T>}
      items={[data.others.length > 0 && <Achievements others={data.others} />]}
    />
  </div>
);

export default Template5;